import { render } from "./upgrade-config.vue?vue&type=template&id=ca32f17c&scoped=true"
import script from "./upgrade-config.vue?vue&type=script&lang=js"
export * from "./upgrade-config.vue?vue&type=script&lang=js"

import "./upgrade-config.vue?vue&type=style&index=0&id=ca32f17c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca32f17c"]])

export default __exports__